import React from 'react';
import {
  NumberField,
  TextField,
  BooleanField,
  SimpleShowLayout,
  ArrayField,
  SingleFieldList,
  ChipField,
} from 'react-admin';
import PositionHospitalMarkupField from 'components/PositionHospitalMarkupField';
import { LocationTypeMarkupBulkUpdateModal } from '../LocationTypeMarkupBulkUpdateModal';

const SummaryTab = () => {
  return (
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField source="name" />
      <TextField label="Display Name" source="display_name" />
      <TextField source="kind" />
      <NumberField source="sequence" />
      <ArrayField source="licenses">
        <SingleFieldList linkType={false}>
          <ChipField source="label_short" />
        </SingleFieldList>
      </ArrayField>
      <BooleanField source="active" />
      <BooleanField source="high_risk" />
      <BooleanField label="Requires Specialty" source="requires_specialty" />
      <TextField label="Qualifications Group Name" source="qualifications_group.name" />
      <ArrayField source="specialties">
        <SingleFieldList linkType={false}>
          <ChipField source="label" />
        </SingleFieldList>
      </ArrayField>
      <PositionHospitalMarkupField />
      <LocationTypeMarkupBulkUpdateModal />

      <TextField source="responsibilities" />
      <TextField component="pre" source="requirements_description" />
    </SimpleShowLayout>
  );
};

export default React.memo(SummaryTab);
